<div
  class="layout-wrapper bg-surface-0 dark:bg-teal-950"
  [class.reveal-rail]="revealRail()"
  [attr.data-theme]="isDarkTheme() ? 'dark' : 'light'">
  @if (showMainLayout()) {
    <app-sidebar />
    <div class="layout-wrapper-content">
      <div class="w-full bg-surface-0 dark:bg-teal-900 shadow-sm relative z-40">
        <div class="w-full px-8">
          <div class="w-full" app-topbar></div>
        </div>
      </div>
      <div class="w-full flex-1 p-8">
        <div class="w-full">
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-configurator />
      <div class="w-full border-t border-surface-200 dark:border-teal-700">
        <div class="w-full px-8">
          <div class="w-full">
            <app-footer />
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="layout-wrapper-content">
      <router-outlet></router-outlet>
    </div>
  }
</div>
<p-toast />
<app-cookie-consent></app-cookie-consent>
